(function($, undefined) {

	/**
	 * @author Radek Šerý
	 *
	 * Automatické srovnávání výšek po AJAXu. Prochází nahrazené snippety a kontroluje, zda v nich nejsou nadefinované
	 * elementy pro srovnání. Pokud jsou, zavolá srovnání s tím, že elementy rovnou předá, tj. není nutné je hledat
	 * opakovaně.
	 *
	 * Nefunguje, pokud EqualHeightItem a její selector jsou obalem snippetu. Nebylo by těžké upravit (krom find a
	 * addBack by se při nenalezené hledalo ještě closest), ale výkonově by to bylo asi trochu zbytečné. Tj. momentálně
	 * hledá pouze směrem dolů.
	 */
	$.nette.ext('equalHeights', {
		init: function() {
			if (! equalHeights) {
				return false;
			}

			var snippetsExt = this.ext('snippets', true);
			var ext = this;

			snippetsExt.after(function($el) {
				ext.eq.call(ext, $el);
			});

			equalHeights.eq();
		}
	}, {
		eq: function($el) {
			var selector = '';

			for (var i in equalHeights) {
				setTimeout(() => {
					if (equalHeights.hasOwnProperty(i) && equalHeights[i] instanceof EqualHeightItem) {
						selector = equalHeights[i].selector;
						var $eq = $el.parent().find(selector);

						if ($eq.length) {
							equalHeights[i].eq(null, $eq);
						}
					}
				}, 0)
			}
		}
	});

})(jQuery);
